import React from 'react'
// CSS
import * as css from '../auditorias/revision/PanelAuditoria.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class InformativoPublicados extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <div className="col-md-12">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className={cx('col-md-12 form-group', 'form__control-label')}>
                            <label className="col-sm-3 control-label">Nóminas sin informar: <span className="badge badge-secondary">{this.props.noInformadas}</span></label>
                            <label className="col-sm-3 control-label">Nóminas peligro: <span className="badge badge-secondary">{this.props.peligro}</span></label>
                            <label className="col-sm-3 control-label">Nóminas sobredotadas: <span className="badge badge-secondary">{this.props.sobredotadas}</span></label>
                            <label className="col-sm-3 control-label">Nóminas Vacías: <span className="badge badge-secondary">{this.props.vacias}</span></label>
                            <label className="col-sm-3 control-label">Cantidad inventarios: <span className="badge badge-secondary">{this.props.totalInventarios}</span></label>
                            <label className="col-sm-3 control-label">Unidades a contar: <span className="badge badge-secondary">{this.props.totalUnidadesContar.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/InformativoPublicados.jsx